import { Component, Input, Output } from '@angular/core';
import { BaseComponent } from '../base/base/base-component.component';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-edit',
    template: `
        <div class="d-flex flex-row gap-1">
            <button class="d-flex gap-2 align-items-center btn action-button" (click)="onEditItem()">
                <img class="icon" src="@imagesDir/edit.png" />
            </button>
        </div>
    `,
    styles: [
        `
            .icon {
                width: 24px;
                height: 24px;
                cursor: pointer;
            }
        `,
    ],
    standalone: false,
})
export class EditComponent extends BaseComponent {
    @Output()
    emitter = new Subject<{ action: string; data: any }>();

    @Input()
    data: any = {};

    ngOnInit() {}

    onEditItem() {
        this.emitter.next({
            action: 'edit',
            data: this.data,
        });
    }
}
